import React, { useState, useEffect, useImperativeHandle, forwardRef, useRef } from 'react';
import { TextField, Typography } from '@mui/material';

export interface FeedbackInputRef {
    getValue: () => string;
    focus: () => void;
}

interface Props {
    initialValue: string;
    isSubmitting: boolean;
}

const FeedbackInput = forwardRef<FeedbackInputRef, Props>(({ initialValue, isSubmitting }, ref) => {
    const [localValue, setLocalValue] = useState(initialValue);
    const inputRef = useRef<HTMLInputElement>(null); // ← para exponer focus()

    useEffect(() => {
        setLocalValue(initialValue);
    }, [initialValue]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setLocalValue(e.target.value);
    };

    useImperativeHandle(ref, () => ({
        getValue: () => localValue,
        focus: () => {
            inputRef.current?.focus();
        }
    }));

    return (
        <>
            <TextField
                fullWidth
                multiline
                rows={8}
                value={localValue}
                onChange={handleChange}
                placeholder="Comparte tu experiencia..."
                disabled={isSubmitting}
                variant="outlined"
                inputRef={inputRef} // ← aquí conectamos el ref interno
                sx={{ bgcolor: 'white', borderRadius: 2, mt: 1 }}
            />
            <Typography variant="caption" color="text.secondary" align="right" display="block">
                {localValue.length}/500 caracteres
            </Typography>
        </>
    );
});

export default React.memo(FeedbackInput);
